import { Dashboard } from "@/components/Dashboard";
import { ButtonDefault } from "./components/Button";
import { deviceService } from "./services/deviceService";
import "../styles/globals.css";

export default function App() {
  return (
    <div>
      <Dashboard />
      <ButtonDefault
        onClick={() =>
          deviceService.clearDevices().then(() => {
            // Reload page to reflect cleared devices
            window.location.reload();
          })
        }
      >
        Clear Map
      </ButtonDefault>
    </div>
  );
}
